import React from 'react'
//import I18n from "i18n-js/index.js.erb"

export default class CheckoutWarning extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="alert alert-dismissable alert-warning">
        {I18n.t('folios_not_balanced_warning')}
      </div>
    );
  };
};